import axios from "axios";
import cn from "classnames";
import React, { useEffect, useState, useRef } from "react";
import { Toaster, toast } from "react-hot-toast";
import { BiLoaderAlt } from "react-icons/bi";
import {
  LightmodeUSDT,
  NewCheck,
  XBR,
  XbrWhite,
  tba,
} from "../../assets/index.js";

import { ReactComponent as SwapVertical } from "../../assets/swapverti.svg";
import ConnectWalletButtonMain from "../../components/ConnectWalletButtonMain.jsx";

import { useTheme } from "@mui/material";
import {
  Contract,
  formatUnits,
  parseUnits,
} from "ethers";
import { useSelector } from "react-redux";
import SuccessfullSwap from "../../components/SuccessfullSwap.jsx";
import ArrowDown from "../../components/svgComponents/ArrowDown.jsx";
import { selectThemeMode } from "../../redux/theme/themeSlice.js";
import { findPoolAddress } from "../../uniswap/pool.js";
import { getTokenTransferApprovalFromRouter } from "../../uniswap/swap.js";
import {
  createSwap,
  fetchTokenAddress,
  getQuotes,
} from "../../uniswap/utils.js";
import {
  ERC20_ABI,
  TBA_TOKEN,
  USDT_TOKEN,
  XBR_TOKEN,
} from "../../web3Utils.js";
import LatestTrades from "./LatestTrades/LatestTrades.jsx";
import PathToSuccess from "./PathToSuccess/PathToSuccess.jsx";
import ReceiveCard from "./ReceiveCard/ReceiveCard.jsx";
import SendCard from "./SendCard/SendCard.jsx";
import { useContextProvider } from '../../context/index.jsx';
import { getEthersSigner } from '../../utils/wagmi.utils.js';
import FailedTransaction from "../../components/FailedTransaction.jsx";

const NewSwapComponent = (props) => {
  const { fetchUsdtPrice, openBuggerMenu } = props;
  const [errorMsg, setErrorMsg] = useState("");
  const [activeTab, setActiveTab] = useState("latest");
  const [usdtBalance, setUsdtBalance] = useState("0.00");
  const [xbrBalance, setXbrBalance] = useState("0.00");
  const [slippageTolerance, setSlippageTolerance] = useState(0.5);
  const [inputSlippageTolerance, setInputSlippageTolerance] = useState("");
  const [approve, setApprove] = useState(false);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [trade, setTrade] = useState(null);
  const [isOpenSlippage, setIsOpenSlippage] = useState(false);
  const [usdt1, setUsdt1] = useState("0.00");
  const [swapConfirmModal, setSwapConfirmModal] = useState(false);
  const [swapdata, setSwapdata] = useState("");
  const [swapTransactionFailModal, setSwapTransactionFailModal] =
    useState(false);
  const [isApproving, setIsApproving] = useState(false);
  const [isSwapping, setIsSwapping] = useState(false);

  const currentMode = useSelector(selectThemeMode);

  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSwap, setIsSwap] = useState(false);
  const [usdtPrice, setUsdtPrice] = useState("");
  const [selectedPrice, setSelectedPrice] = useState("");
  const [selectedPriceXBR, setSelectedPriceXBR] = useState("");
  const [selectedPriceTBA, setSelectedPriceTBA] = useState("");

  const [holdersCount, setHoldersCount] = useState("0");
  const [liquidity, setLiquidity] = useState("");
  const [totalSupply, setTotalSupply] = useState("");
  const [fdv, setFdv] = useState("");
  const [volume24h, setVolume24h] = useState("0");
  const [sendValue, setSendValue] = useState("");
  const [receiveValue, setReceiveValue] = useState("");
  const [isInsufficientBalance, setIsInsufficientBalance] = useState(false);
	const {walletAddress, jsonRpcProvider}= useContextProvider();

  const handlePopClose = () => {
    setOpen(false);
    setTrade(null);
    setOpen1(false);
    setOpen3(false);
  };

  const [tbaBalance, setTbaBalance] = useState("1.111");
  const handleSlippageChange = (value) => {
    // If the input is empty, set slippageTolerance to 0
    if (value === "") {
      setInputSlippageTolerance("");
      setSlippageTolerance(0);
      return;
    }

    // Ensure the input value is a number and within the allowed range (0 to 15)
    const regex = /^\d{0,2}(\.\d{0,2})?$/;

    // Check if the input matches the regex and is within the allowed range (0 to 15)
    if (regex.test(value) && parseFloat(value) <= 15) {
      setInputSlippageTolerance(value);

      // If the input is a valid number, update the slippage tolerance state
      const parsedValue = parseFloat(value);
      if (!isNaN(parsedValue)) {
        setSlippageTolerance(parsedValue);
      } else {
        setSlippageTolerance(0);
      }
    }
  };


  const fetchBalances = async (walletAddress ,jsonRpcProvider) => {
    try {
      const usdcContract = new Contract(USDT_TOKEN.address, ERC20_ABI, jsonRpcProvider);
      const xbrContract = new Contract(XBR_TOKEN.address, ERC20_ABI, jsonRpcProvider);
      const tbaContract = new Contract(TBA_TOKEN.address, ERC20_ABI, jsonRpcProvider);

      const usdcBalance = formatUnits(await usdcContract.balanceOf(walletAddress), 6);

      const xbrBalance = formatUnits(await xbrContract.balanceOf(walletAddress), 18);

      const tbaBalance = formatUnits(await tbaContract.balanceOf(walletAddress), 18);

      setUsdtBalance(usdcBalance);
      setXbrBalance(xbrBalance);
      setTbaBalance(tbaBalance);
      return { usdcBalance, xbrBalance };
    } catch (error) {
      console.error("Error fetching balances:", error);
    }
  };

  const fetchpricedata = async (walletAddress ,jsonRpcProvider) => {
    try {
      const XBR = await fetchTokenAddress("XBR", jsonRpcProvider);
      const USDT = await fetchTokenAddress("USDT", jsonRpcProvider);
      const TBA = await fetchTokenAddress("TBA", jsonRpcProvider);

      const poolAddressXBR = await findPoolAddress(
        USDT.address,
        XBR.address,
        jsonRpcProvider
      );

      const poolAddressTBA = await findPoolAddress(
        USDT.address,
        TBA.address,
        jsonRpcProvider
      );

      const URL = process.env.REACT_APP_API;
      const responsesXBR = await axios.get(`${URL}/v1/xbr/coin-price?`, {
        params: {
          address: poolAddressXBR.poolAddress,
          count: 157860000,
        },
      });
      const coinMarketCapDataXBR = await responsesXBR.data.response
        .coinMarketCapResponseData.data;
      const priceXBR = await coinMarketCapDataXBR?.priceUsd;
      setSelectedPriceXBR(priceXBR);
      const responsesTBA = await axios.get(`${URL}/v1/xbr/coin-price?`, {
        params: {
          address: poolAddressTBA.poolAddress,
          count: 157860000,
        },
      });
      const coinMarketCapDataTBA = await responsesTBA.data.response
        .coinMarketCapResponseData.data;
      const priceTBA = await coinMarketCapDataTBA?.priceUsd;
      setSelectedPriceTBA(priceTBA);
    } catch (error) {
      console.error("Error fetching market data:", error);
    }
  };

  const pricemap = {
    XBR: selectedPriceXBR,
    TBA: selectedPriceTBA,
    USDT: usdtPrice,
  };

  const formatBalance = (balance) => {
    // Ensure the balance is treated as a number
    const num = parseFloat(balance);
    if (num >= 1e12) {
      return (num / 1e12).toFixed(1).replace(/\.0$/, "") + "T"; // Trillions
    } else if (num >= 1e9) {
      return (num / 1e9).toFixed(1).replace(/\.0$/, "") + "B"; // Billions
    } else if (num >= 1e6) {
      return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M"; // Millions
    } else if (num >= 1e3) {
      return (Math.floor(num / 1e2) / 10).toFixed(1).replace(/\.0$/, "") + "K"; // Thousands
    } else {
      return num.toFixed(3).replace(/\.00$/, ""); // Output as a string with two decimal places
    }
  };

  const formatBalanceForPrice = (balance) => {
    // Ensure the balance is treated as a number
    const num = parseFloat(balance);
    if (num >= 1e12) {
      return (num / 1e12).toFixed(1).replace(/\.0$/, "") + "T"; // Trillions
    } else if (num >= 1e9) {
      return (num / 1e9).toFixed(1).replace(/\.0$/, "") + "B"; // Billions
    } else if (num >= 1e6) {
      return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M"; // Millions
    } else if (num >= 1e3) {
      return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "K"; // Thousands
    } else {
      return num.toFixed(6).replace(/\.?0+$/, ""); // Output as a string without unnecessary trailing zeros
    }
  };

  const validateInput = (value) => {
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      value === 0 ||
      value === "0"
    ) {
      return false; // Return false for null or undefined values
    }
    const regex = /^[0-9]*\.?[0-9]*$/; // Regular expression to match numbers with optional decimal point
    return regex.test(value);
  };
  function checkTokenBalance(tokenName, balance) {
    const validTokens = {
      XBR: "0.00",
      USDT: "0.00",
      TBA: "0.00",
    };

    if (validTokens[tokenName] && balance === validTokens[tokenName]) {
      setOpen3(true);
      setTimeout(handlePopClose, 3000);
      return true;
    }

    return false;
  }
  const approveForSwap = async (selectedOption) => {
    //console.log("selectedToken.name", selectedToken.name);
		const signer = await getEthersSigner()
    if (!signer) {
      console.error('no signer')
    }

    if (
      checkTokenBalance(selectedToken.name, xbrBalance) ||
      checkTokenBalance(selectedToken.name, usdtBalance) ||
      checkTokenBalance(selectedToken.name, tbaBalance)
    ) {
      return;
    }
    setIsLoading(true);
    setIsApproving(true);
    try {
      //console.log("Approve for Swap", selectedOption);
      const value = sendValue;
      let isToastDisplayed = false;

      if (
        value === null ||
        value === undefined ||
        value === "" ||
        value === 0 ||
        value === "0"
      ) {
        if (!isToastDisplayed) {
          isToastDisplayed = true;
          toast.error("Please enter a valid amount", {
            duration: 2000,
            onClose: () => {
              isToastDisplayed = false;
            },
          });
        }
        return;
      }
      const unit =
        selectedOption === "TBA" || selectedOption === "XBR" ? 18 : 6;
      const tokenAmount = parseFloat(value).toFixed(unit);

      const approve = await getTokenTransferApprovalFromRouter(
        selectedOption,
        parseUnits(tokenAmount.toString(), unit),
        signer,
				jsonRpcProvider
      );

      if (approve === "Failed") {
        setOpen1(true);
        setTimeout(handlePopClose, 15000);
      }
      if (approve !== "Failed" && approve !== null && approve !== undefined) {
        setApprove(true);
        setIsLoading(false);
        setIsApproving(false);
      }
      return approve;
    } catch (error) {
      setIsApproving(false);
      setIsLoading(false);
      console.error(error);
      throw error;
    }
  };

  const swap = async () => {
    setIsSwapping(true);
    try {
			const signer = await getEthersSigner()
      let [firstToken, secondToken, firstAmount, secondAmount] = [
        selectedToken.name,
        selectedToken2.name,
        sendValue,
        receiveValue,
      ];

      if (!validateInput(firstAmount) || !validateInput(secondAmount)) {
        toast.error("Please enter a valid amount", {
          duration: 1000,
        });
        return;
      }

      const createSwapRespone = await createSwap(
        firstToken,
        secondToken,
        Number(firstAmount),
        Number(secondAmount),
        slippageTolerance,
        walletAddress,
				jsonRpcProvider,
				signer
      );

      setSwapdata(createSwapRespone);
      if (createSwapRespone === "Failed") {
        setIsSwapping(false);
        setOpen1(true);
        setTimeout(handlePopClose, 15000);
      }
      if (
        createSwapRespone !== "Failed" &&
        createSwapRespone !== null &&
        createSwapRespone !== undefined
      ) {
        setSwapConfirmModal(true);
        const tradeObj = {
          transactionHash: createSwapRespone,
          firstAmount,
          secondAmount,
        };
        setTrade(tradeObj);
        setIsSwap(true);
        setOpen(true);
        setTimeout(() => {
          handlePopClose();
          setIsSwap(false);
          setIsSwapping(false);
          setSwapConfirmModal(false);
          setApprove(false);
          setSendValue("");
          setReceiveValue("");
        }, 15000);
      }
    } catch (error) {
      setIsSwapping(false);
      setErrorMsg(error.message);
      setOpen1(true);
      setSwapTransactionFailModal(true);
      setTimeout(handlePopClose, 15000);
      console.error(error);
      throw error;
    }
  };

  const theme = useTheme();

  const dropdownRef = useRef(null);
  const dropdownRef1 = useRef(null);
  const dropdownRef2 = useRef(null);

  useEffect(() => {
    // Function to close dropdown when clicked outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
      if (
        dropdownRef2.current &&
        !dropdownRef2.current.contains(event.target)
      ) {
        setIsOpen2(false);
      }
    };

    // Adding event listener to the document body
    document.addEventListener("mousedown", handleClickOutside);

    // Cleaning up the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const cardStyle =
    theme.palette.mode === "light"
      ? {
          backgroundColor: "white", // Assuming grey is defined correctly in your theme
          color: theme.palette.text.primary,
        }
      : {
          backgroundColor: "#02042C", // Dark mode or other default style
          color: theme.palette.text.primary,
        };

  const tokens = [
    {
      id: "XBR",
      name: "XBR",
      image: currentMode === "light" ? XbrWhite : XBR,
    },
    {
      id: "USDT",
      name: "USDT",
      image: LightmodeUSDT,
    },
    {
      id: "TBA",
      name: "TBA",
      image: tba,
    },
  ];

  const [selectedToken, setSelectedToken] = useState(tokens[1]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedToken2, setSelectedToken2] = useState(tokens[0]);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpenDetails, setIsOpenDetails] = useState(false);

  const newOnChangeSwapInputs = async (value, type, data, type2) => {
    if (!value || value === undefined || value === null || value === "") {
      setSendValue("");
      setReceiveValue("");
      setIsInsufficientBalance(false);
      return;
    }

    const regex = /^(?!-)[0-9]*[.]?[0-9]*$/;
    try {
      const balanceMap = {
        XBR: xbrBalance,
        USDT: usdtBalance,
        TBA: tbaBalance,
      };

      const balance =
        type === selectedToken.name ? parseFloat(balanceMap[type]) : 0;

      // Check if the entered value exceeds the balance
      if (parseFloat(value) > balance) {
        setIsInsufficientBalance(true);
      } else {
        setIsInsufficientBalance(false);
      }

      if (data === 1) {
        if (regex.test(value)) {
          setSendValue(value);
          const result =
            value !== "" && value > parseFloat(0)
              ? await getQuotes(type, type2, value, jsonRpcProvider)
              : "";

          setReceiveValue(result);
        }
      } else {
        if (regex.test(value)) {
          setReceiveValue(value);
          const result =
            value !== "" && value > parseFloat(0)
              ? await getQuotes(type, type2, value, jsonRpcProvider)
              : "";
          setSendValue(result);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getFormattedBalance = (name) => {
    const balanceMap = {
      XBR: `${formatBalanceForPrice(parseFloat(xbrBalance))}`,
      USDT: `${formatBalanceForPrice(parseFloat(usdtBalance))}`,
      TBA: `${formatBalanceForPrice(parseFloat(tbaBalance))}`,
    };
    return balanceMap[name] || "00.00";
  };
  const swapTokens = (value) => {
    if (value === 1) {
      newOnChangeSwapInputs(
        receiveValue,
        selectedToken2.name,
        1,
        selectedToken.name
      );
      const temp = selectedToken;
      setSelectedToken(selectedToken2);
      setSelectedToken2(temp);
    } else {
      newOnChangeSwapInputs(
        receiveValue,
        selectedToken2.name,
        2,
        selectedToken.name
      );
      const temp = selectedToken2;
      setSelectedToken2(selectedToken);
      setSelectedToken(temp);
    }
  };
  const newSwapOptions = async () => {
    await newOnChangeSwapInputs(
      receiveValue,
      selectedToken2.name,
      1,
      selectedToken.name
    );
    const temp = selectedToken;
    setSelectedToken(selectedToken2);
    setSelectedToken2(temp);
  };
  const newMax = async (type, inputType) => {
    try {
      const balances = await fetchBalances(walletAddress ,jsonRpcProvider);
      const balanceMap = {
        XBR: balances.xbrBalance,
        USDT: balances.usdcBalance,
        TBA: tbaBalance,
      };

      const balance = balanceMap[type] || "0.00";

      await newOnChangeSwapInputs(
        balance,
        type,
        inputType,
        type === selectedToken.name ? selectedToken2.name : selectedToken.name
      );
    } catch (error) {
      console.error("Error getting max balances", error);
    }
  };

  const handleTokenChange = (token, isFirst) => {
    if (isFirst) {
      setSelectedToken(token);
      if (sendValue) {
        newOnChangeSwapInputs(sendValue, token.name, 1, selectedToken2.name);
      }
    } else {
      setSelectedToken2(token);
      if (receiveValue) {
        newOnChangeSwapInputs(receiveValue, token.name, 2, selectedToken.name);
      }
    }
  };

  const fetchMarketData = async () => {
    try {
      const token0 = await fetchTokenAddress(
        selectedToken.name,
        jsonRpcProvider
      );
      const token1 = await fetchTokenAddress(
        selectedToken2.name,
        jsonRpcProvider
      );
      const { poolAddress } = await findPoolAddress(
        token0.address,
        token1.address,
        jsonRpcProvider
      );
      const URL = process.env.REACT_APP_API;
      const responses = await axios.get(`${URL}/v1/xbr/coin-price?`, {
        params: {
          address: poolAddress,
          count: 157860000,
        },
      });

      const coinMarketCapData = await responses.data.response
        .coinMarketCapResponseData.data;
      const poolInfoHolders = formatBalance(
        coinMarketCapData.poolInfoD.holders
      );
      const liquidity = formatBalance(coinMarketCapData?.poolInfoD.liquidity);
      const totalSupply = coinMarketCapData?.totalSupply;
      const fdv = formatBalance(coinMarketCapData?.fdv);
      const volume24h = formatBalance(coinMarketCapData?.volume24h);
      const price = await coinMarketCapData?.priceUsd;

      setSelectedPrice(price);
      setHoldersCount(poolInfoHolders);
      setLiquidity(liquidity);
      setTotalSupply(formatBalance(totalSupply));
      setFdv(fdv);
      setVolume24h(volume24h);
    } catch (error) {
      console.error("metamask", "Error fetching market data:", error);
    }
  };

  const fetchMarketDataDefault = async () => {
    try {
      const poolAddress = "0x1eb8DFe76eE03Fd68Aa58f849CAD5590B4D12617";
      const URL = process.env.REACT_APP_API;
      const responses = await axios.get(`${URL}/v1/xbr/coin-price?`, {
        params: {
          address: poolAddress,
          count: 157860000,
        },
      });

      const coinMarketCapData = await responses.data.response
        .coinMarketCapResponseData.data;
      const poolInfoHolders = formatBalance(
        coinMarketCapData.poolInfoD.holders
      );
      const liquidity = formatBalance(coinMarketCapData?.poolInfoD.liquidity);
      const totalSupply = coinMarketCapData?.totalSupply;
      const fdv = formatBalance(coinMarketCapData?.fdv);
      const volume24h = formatBalance(coinMarketCapData?.volume24h);
      const price = await coinMarketCapData?.priceUsd;

      setSelectedPrice(price);
      setHoldersCount(poolInfoHolders);
      setLiquidity(liquidity);
      setTotalSupply(formatBalance(totalSupply));
      setFdv(fdv);
      setVolume24h(volume24h);
    } catch (error) {
      console.error("Error fetching market data:", error);
    }
  };

  const fetchUSDTPrice = async () => {
    const price = await fetchUsdtPrice();
    setUsdtPrice(await price);
  };

  const fetchPrice = async (address) => {
    const URL = `${process.env.REACT_APP_API}/v1/xbr/token-prices?address=${address}`;
    const response = await axios.get(URL);
    return response?.data?.data?.attributes?.price_usd;
  };

  function formatTbaPrice(price) {
    // Ensure the price is a number
    if (typeof price !== "number" || isNaN(price)) return "NaN";

    // Convert the price to a string in fixed-point notation to ensure precision
    let priceStr = price.toFixed(25); // Use enough precision to capture all significant digits

    // Find the index of the decimal point
    let decimalIndex = priceStr.indexOf(".") + 1;

    // Find the index of the first non-zero digit after the decimal point
    let firstNonZeroIndex = decimalIndex;
    while (
      priceStr[firstNonZeroIndex] === "0" &&
      firstNonZeroIndex < priceStr.length
    ) {
      firstNonZeroIndex++;
    }

    // Count the number of leading zeroes
    let zeroCount = firstNonZeroIndex - decimalIndex;

    // Get the significant digits part (adjust the length as needed)
    let significantPart = priceStr.substring(
      firstNonZeroIndex,
      firstNonZeroIndex + 3
    );

    // Construct the formatted string
    return `0.0(${zeroCount})${significantPart}`;
  }

  const fetch1USDT = async () => {
    const quotes = await getQuotes(
      selectedToken.name,
      selectedToken2.name,
      1,
      jsonRpcProvider
    );
    if (selectedToken.name === "TBA") {
      const TBA = await fetchPrice(
        "0x7e1AE068Ac4e0ffD7a84750c2FB093A0EAE9aEa2"
      );
      setUsdt1(formatTbaPrice(Number(TBA)));
    } else {
      setUsdt1(formatBalanceForPrice(quotes));
    }
  };

  useEffect(() => {
    fetchUSDTPrice();
  }, []);

  useEffect(() => {
		if (walletAddress && jsonRpcProvider) {
			fetchBalances(walletAddress ,jsonRpcProvider);
			fetchpricedata(walletAddress ,jsonRpcProvider);

		}
    fetchMarketData();
    fetch1USDT();
    if (holdersCount === "0") {
      fetchMarketDataDefault();
    }
  }, [newOnChangeSwapInputs, selectedToken, selectedToken2, walletAddress]);

  useEffect(() => {
    setApprove(false);
  }, [sendValue, receiveValue]);

  function safeParseNumber(value) {
    const number = Number(value);
    return isNaN(number) ? 0 : number;
  }

  return (
    <div>
      <div className="relative max-w-140 mx-auto bg-white dark:bg-darkCardBg rounded-b-3xl mb-[24px] sm:mb-18">
        <div className={"relative"}>
          <div
            className={
              "relative w-full rounded-3xl flex flex-col items-center justify-center p-4 pt-0"
            }
          >
            <div className="flex flex-col items-start justify-start gap-4 w-full relative mb-6">
              {/* Card 1 */}

              <SendCard
                cardName={"Send"}
                cardStyle={cardStyle}
                isInsufficientBalance={isInsufficientBalance}
                connectedAccount={walletAddress}
                paletteMode={theme.palette.mode}
                dropdownRef1={dropdownRef1}
                setIsOpen={setIsOpen}
                isOpen={isOpen}
                selectedToken={selectedToken}
                tokens={tokens}
                swapTokens={swapTokens}
                handleTokenChange={handleTokenChange}
                getFormattedBalance={getFormattedBalance}
                newOnChangeSwapInputs={newOnChangeSwapInputs}
                selectedToken2={selectedToken2}
                formatBalanceForPrice={formatBalanceForPrice}
                safeParseNumber={safeParseNumber}
                sendValue={sendValue}
                pricemap={pricemap}
                newMax={newMax}
                loading={loading}
                approve={approve}
                setLoading={setLoading}
                swap={swap}
                isSwapping={isSwapping}
                swapConfirmModal={swapConfirmModal}
                newCheck={NewCheck}
              />

              {/* Swap Image */}
              <button
                type="button"
                className="w-10 h-10 bg-deepBlue rounded-lg border border-white absolute transition-colors duration-300 hover:bg-[#8C96FF] active:bg-[#1E31FF] top-[calc(50%-20px)] left-1/2 transform -translate-x-1/2 flex items-center justify-center z-20 shadow-swapButton"
              >
                <SwapVertical
                  className="text-white"
                  onClick={() => newSwapOptions()}
                />
              </button>

              {/* Card 2 */}

              <ReceiveCard
                labelName={"Receive"}
                cardStyle={cardStyle}
                paletteMode={theme.palette.mode}
                dropdownRef2={dropdownRef2}
                selectedToken2={selectedToken2}
                setIsOpen2={setIsOpen2}
                isOpen2={isOpen2}
                tokens={tokens}
                swapTokens={swapTokens}
                handleTokenChange={handleTokenChange}
                getFormattedBalance={getFormattedBalance}
                newMax={newMax}
                newOnChangeSwapInputs={newOnChangeSwapInputs}
                selectedToken={selectedToken}
                receiveValue={receiveValue}
                formatBalanceForPrice={formatBalanceForPrice}
                safeParseNumber={safeParseNumber}
                pricemap={pricemap}
              />
            </div>

            {/* Slippage */}
            <div className="w-full z-0 bg-white shadow-smallShadow rounded-lg md:rounded-none md:shadow-none dark:bg-navyAccent shadow-slippageShadow mb-6">
              <div
                className={cn(
                  " w-full rounded-md duration-500 ease-in-out overflow-hidden h-18 shadow-smallShadow",
                  { "h-[130px] md:h-44": isOpenSlippage }
                )}
              >
                <div className="flex justify-between items-center w-full px-6 md:px-8 py-4 md:border-b md:border-lightGrayBlue dark:border-darkSlateBlue">
                  <h3
                    className={
                      "text-base font-medium leading-6 font-inter text-black dark:text-white"
                    }
                  >
                    Max Slippage
                  </h3>
                  <div className="flex gap-1 flex-row items-center justify-between">
                    {/* Button to toggle slippage options */}
                    <div className="relative w-full flex items-center">
                      <button
                        type="button"
                        onClick={() => setIsOpenSlippage(!isOpenSlippage)}
                        className="h-10 py-1 pl-4 pr-3 text-xs md:text-sm leading-[18px]
                         md:leading-[21px] bg-lightBlue dark:bg-darkButBg dark:text-white
                          border border-white dark:border-darkCardBg dark:hover:border-[#5663F2] hover:border-[#5663F2] dark:active:bg-[#3C3A66] active:bg-[#D8E2FF] shadow-selectionShadow 
                          text-black font-medium rounded-md flex items-center justify-center gap-2"
                      >
                        {slippageTolerance}%
                        <span
                          className={cn(
                            "w-[14px] h-[14px] flex justify-center items-center",
                            {
                              "rotate-180": isOpenSlippage,
                            }
                          )}
                        >
                          <ArrowDown />
                        </span>
                      </button>
                    </div>
                  </div>
                </div>

                <div className={"flex gap-2 px-6 md:px-8 md:pt-4 pb-6 w-full"}>
                  {/* Custom slippage input */}
                  <form className="w-full relative">
                    <label htmlFor="slippage-input" className="sr-only">
                      Choose your percentage
                    </label>
                    <input
                      id="slippage-input"
                      type="text"
                      className={
                        "w-full h-[46px] md:h-16 pl-4 md:pl-6 py-3 pr-3 bg-lightBlue dark:bg-darkButBg text-sm leading-[21px] font-normal md:leading-6 md:text-base md:font-light uppercase rounded-lg text-lightBlack placeholder-lightBlack dark:text-lightWhite dark:placeholder:text-lightWhite"
                      }
                      placeholder={`${slippageTolerance}%`}
                      value={slippageTolerance}
                      onChange={(e) => handleSlippageChange(e.target.value)}
                    />
                    <div className="absolute top-0 right-3 flex items-center gap-1 md:gap-2 h-full">
                      {[0.1, 0.5, 1.0].map((value) => (
                        <button
                          type="button"
                          key={value}
                          className={cn(
                            "h-[30px] md:h-10 px-2 md:px-4 font-semibold rounded-md flex justify-center items-center shadow-selectionShadow bg-white text-black dark:text-white hover:bg-[#D8E2FF]  dark:bg-darkCardBg",
                            {
                              "!bg-deepBlue text-white border border-white":
                                slippageTolerance === value,
                              "border border-transparent hover:border-deepBlue":
                                slippageTolerance !== value,
                            }
                          )}
                          onClick={() => handleSlippageChange(value)}
                        >
                          {`${value}%`}
                        </button>
                      ))}
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {walletAddress && (
              <div
                className={cn(
                  "w-full p-3 px-6 md:px-8 pb-4 overflow-hidden duration-500 ease-in-out z-0 h-[42px]",
                  {
                    "!h-[117px] transition-height": isOpenDetails,
                  }
                )}
              >
                <button
                  type="button"
                  className={"flex justify-between items-center w-full mb-3"}
                  onClick={() => setIsOpenDetails(!isOpenDetails)}
                >
                  <span className="text-semiBlack dark:text-semiWhite md:text-sm md:leading-4 tracking-[0.15px] uppercase">
                    1 {selectedToken.name} = {usdt1} {selectedToken2.name}
                  </span>
                  <span>
                    <span
                      className={cn(
                        "w-[14px] h-[14px] flex justify-center items-center",
                        {
                          "rotate-180": isOpenDetails,
                        }
                      )}
                    >
                      <ArrowDown />
                    </span>
                  </span>
                </button>

                <div className="flex justify-between items-center gap-2 w-full mb-2 md:mb-3">
                  <p className="text-semiBlack dark:text-semiWhite text-xs leading-[14px] md:text-sm md:leading-4 md:tracking-[0.15px]">
                    Max slippage
                  </p>
                  <span className="flex-1 border border-lightGrayBlue dark:border-darkSlateBlue" />
                  <p className="text-black dark:text-white text-xs md:text-sm leading-6">
                    {slippageTolerance}%
                  </p>
                </div>

                <div className="flex justify-between items-center gap-2 w-full mb-2 md:mb-3">
                  <p className="text-semiBlack dark:text-semiWhite text-xs leading-[14px] md:text-sm md:leading-4 md:tracking-[0.15px]">
                    Receive at least
                  </p>
                  <span className="flex-1 border border-lightGrayBlue dark:border-darkSlateBlue" />
                  <p className="text-black dark:text-white text-xs md:text-sm leading-6">
                    {receiveValue ? formatBalance(receiveValue) : "0.00"}{" "}
                    {selectedToken2.name}
                  </p>
                </div>
              </div>
            )}

            <div className="w-full flex justify-center mt-4 z-0">
              {walletAddress ? (
                <div className="w-full flex gap-4">
                  {!approve ? (
                    <button
                      type="button"
                      className={cn(
                        "w-full h-14 text-base leading-6 font-medium rounded-lg text-semiBlack bg-iceBlue dark:border  dark:border-white dark:bg-darkCardBg dark:text-semiWhite transition-colors duration-300  flex items-center justify-center",
                        {
                          "!bg-deepBlue hover:!bg-vividBlueViolet active:!bg-[#1E31FF] transition-all duration-300 !text-white !border-white shadow-swapButton":
                            Number(sendValue) > 0 &&
                            Number(receiveValue) > 0 &&
                            !isInsufficientBalance,
                        }
                      )}
                      onClick={() => {
                        if (!approve && !isLoading && !isInsufficientBalance) {
                          setIsLoading(true);
                          approveForSwap(selectedToken.name)
                            .then(() => {
                              setIsLoading(false);
                              setIsApproving(false);
                            })
                            .catch(() => {
                              setIsLoading(false);
                              setIsApproving(false);
                            });
                        }
                      }}
                    >
                      {isApproving && (
                        <div>
                          <BiLoaderAlt className="animate-spin text-gray-50" />
                        </div>
                      )}
                      {approve ? "Approved" : "Approve"}
                    </button>
                  ) : (
                    <button
                      type="button"
                      className={cn(
                        "w-full h-14 text-base leading-6 font-medium  rounded-lg text-semiBlack bg-iceBlue dark:border dark:border-white dark:border-white dark:bg-darkCardBg dark:text-semiWhite transition-colors duration-300  flex items-center justify-center",
                        {
                          "!bg-deepBlue hover:!bg-vividBlueViolet active:!bg-[#1E31FF] transition-all duration-300 !text-white !border-white shadow-swapButton":
                            approve || !isSwapping,
                        }
                      )}
                      onClick={() => {
                        if (!loading && approve) {
                          setLoading(true);
                          swap()
                            .then(() => {
                              setLoading(false);
                            })
                            .catch(() => {
                              setLoading(false);
                            });
                        }
                      }}
                      disabled={!approve || isSwapping}
                    >
                      {isSwapping && (
                        <div>
                          <BiLoaderAlt className="animate-spin text-gray-50" />
                        </div>
                      )}
                      {swapConfirmModal ? "Swapped" : "Swap Token"}
                    </button>
                  )}
                </div>
              ) : (
                <ConnectWalletButtonMain />
              )}
            </div>
          </div>
        </div>

        {swapTransactionFailModal && (
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <FailedTransaction
              onClose={() => setSwapTransactionFailModal(false)}
            />
          </div>
        )}
        {swapConfirmModal && (
          <div className="z-50">
            <SuccessfullSwap
              sendValue={sendValue}
              receiveValue={receiveValue}
              selectedToken={selectedToken}
              selectedToken2={selectedToken2}
              swapdata={swapdata}
              onClose={() => {
                setSwapConfirmModal(false);
                setApprove(false);
              }}
            />
          </div>
        )}
        <Toaster />
      </div>

      <div className="grid lg:grid-cols-2 gap-6 md:gap-8 max-w-full">
        <PathToSuccess
          fdv={fdv}
          liquidity={liquidity}
          holdersCount={holdersCount}
          totalSupply={totalSupply}
          selectedTokenOneName={selectedToken.name}
          selectedTokenTwoName={selectedToken2.name}
        />
        <LatestTrades
          activeTab={activeTab}
          connectedAccount={walletAddress}
          selectedToken={selectedToken}
          selectedToken2={selectedToken2}
          swapConfirmModal={swapConfirmModal}
        />
      </div>
    </div>
  );
};

export default NewSwapComponent;
